<div class="table-responsive" *ngIf="fiyatlar">
  <table class="table card-table table-vcenter datatable">
    <thead>
      <tr>
        <th>Tarih</th>
        <th class="text-right">Fiyat (TL/lt.)</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let f of fiyatlar">
        <td>{{ f.tarih | date: 'dd.MM.yyyy' }}</td>
        <td class="text-right">{{ f.fiyat.toFixed(2) }} TL</td>
        <td class="text-right">
          <div class="btn btn-sm btn-success" (click)="incele(f.id)">İncele</div>
          <div class="btn btn-sm btn-danger ml-3" (click)="sil(f)">Sil</div>
        </td>
      </tr>
    </tbody>
  </table>
</div>